<template>
  <div class="home">
    <main role="main" class="ml-sm-auto col-xl-10 px-4">
      <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
        <h1 class="h2">Page non trouvé !</h1>
      </div>
    </main>
  </div>
</template>

<script>

export default {
  
}
</script>